import {priority} from '@priority-software/priority-proto-api/lib';
import {buildServerCall} from '../../../../../services/wcfService';
import {
    getConnection,
    getCurSession,
    getStatusID,
    setIsBPMChanged
} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {js2xml} from 'xml-js';
import {AlertOverviewType, GWTRulesType} from './types';
import {bpmRulesStorage} from '../BPM.rules.storage';
import {DocumentFields} from './enum';
import {coverLetterToXmlData} from '../utils/coverLetterSerializer';

const getPdfValue = (rule: priority.netitems.form.IAlert) => {
    if (rule.Pdf && rule.WordTemplates) {
        return DocumentFields.selectedFormatAndPdf;
    } else if (rule.WordTemplates) {
        return DocumentFields.selectedFormat;
    } else if (rule.Pdf) {
        return DocumentFields.selectedPdf;
    }
    return DocumentFields.deslectedPdf;
};

export const bpmRuleSave = async (
    rule: priority.netitems.form.IAlert,
    fromStatus: string,
    toStatus: string
) => {
    const methodName = 'BPMAlertSaveNew';
    const reason = 'BPMAlertSaveNew';
    let messages = rule.Messages?.reduce(
        (acc, message, index) => {
            acc[Number(message.Language) === 1 ? 'heb' : 'eng'] = message;

            return acc;
        },
        {
            eng: {Subject: '', Message: ''} as priority.netitems.form.IAlertMessage,
            heb: {Subject: '', Message: ''} as priority.netitems.form.IAlertMessage
        }
    );

    if (!messages) {
        /** reset for Message to empty in case there is a CoverLetter so the code won't break */
        messages = {
            eng: {Subject: '', Message: ''} as priority.netitems.form.IAlertMessage,
            heb: {Subject: '', Message: ''} as priority.netitems.form.IAlertMessage
        };
    }

    const fromStatusId = getStatusID(fromStatus)?.toString();
    const toStatusId = getStatusID(toStatus)?.toString();
    const storageData = bpmRulesStorage.getStorage(getCurSession());
    const coverLetterData = coverLetterToXmlData(rule);

    const mappedRule = {
        AlertValues: {
            Alert: {
                type: GWTRulesType.BPMStatusRules,
                id1: fromStatusId,
                id2: toStatusId,
                alert: rule.AlertNumber,
                active: rule.Active ? 1 : 0,
                description: rule.Description
            },
            BPMStatusRule: {
                time: rule.BPM?.TimeValue,
                timeunit: rule.BPM?.TimeUnit,
                timefield: rule.BPM?.TimeField
            },
            Action: {
                messagetype: rule.MessageType,
                mailtype: rule.MailType,
                tostatus: rule?.BPM?.ToStatus || '',
                recipuser: rule.RecipientUser?.[0] || '',
                recipgroup: rule.RecipientGroup?.[0] || '',
                recipemail: rule.RecipientMail[0] || '',
                recipfield: rule.RecipientField,
                subject: coverLetterData?.hebrewCoverLetter?.Subject || messages.heb.Subject,
                message: messages.heb.Message,
                engsubject: coverLetterData?.englishCoverLetter?.Subject || messages.eng.Subject,
                engmessage: messages.eng.Message,
                document: rule.Document || '',
                docformat: rule.DocumentFormat || '',
                pdf: getPdfValue(rule),
                extfiles: rule.ExtFile ? 1 : 0,
                webhook: rule.WebHook,
                coverletter: coverLetterData?.hebrewCoverLetter?.Message,
                coverletter2: coverLetterData?.englishCoverLetter?.Message
            },
            Conditions: rule.AlertConds.map(condition => ({
                curvalue: condition.CurrentValue,
                field: condition.ConditionField,
                op: condition.ConditionOperator,
                value: condition.ConditionValue || '',
                secvalue: condition.ConditionSecondValue || ''
            })),
            ConditionsOperator: {
                operator: rule.ConditionsOperator ? 1 : 0
            },
            Arrays: {
                recipuser: mappedMultipleValues(rule.RecipientUser || []),
                recipgroup: mappedMultipleValues(rule.RecipientGroup || []),
                recipemail: mappedMultipleValues(rule.RecipientMail || []),
                validallusers: mappedMultipleValues(rule.Form?.ValidUser || []),
                validgroup: mappedMultipleValues(rule.Form?.ValidGroup || [])
            }
        }
    };

    const xml = window['common'].compressString(js2xml(mappedRule, {compact: true}));

    const parameters = {
        session: [getCurSession()],
        xml: [xml]
    };

    const res = await buildServerCall(methodName, parameters, reason, true, getConnection);
    const rules = (res as any).BPM[0].Rules?.[0].Rule;

    // Triggers GWT state change flag
    setIsBPMChanged(true);

    if (rules) {
        storageData.setRules(fromStatusId, toStatusId, rules);
    }

    return rules as AlertOverviewType[];
};

const mappedMultipleValues = (values: (string | number | Long)[] = []) => {
    if (values.length > 1) {
        return values.slice(1).join('\r');
    }
    return '';
};
